"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TABLE_HEAD_COLUMNS = exports.STATUS_OPTIONS = exports.SPECIFICITIES = exports.ALL_HEAD_COLUMNS_WITH_SPECIFICITIES = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
var _TableToolbar = require("./tableComponents/TableToolbar");
var _CustomTableHead = _interopRequireDefault(require("./tableComponents/CustomTableHead"));
var _CustomTableBody = require("./tableComponents/CustomTableBody");
var _Translations = require("react-platform-components/dist/Translations");
var _tableHooks = require("./tableHooks");
var _reactUse = require("react-use");
var _excluded = ["headColumns", "useProducts", "useCategories", "useSpecificities", "intl"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: "100%"
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2)
    },
    table: {
      minWidth: 1000
    },
    circularProgressWrapper: {
      display: "grid",
      placeItems: "center",
      padding: "2.5rem"
    }
  };
});
var STATUS_OPTIONS = [{
  value: "waiting",
  label: "En attente",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "En attente",
    defaultMessage: "En attente"
  })
}, {
  value: "published",
  label: "Publié",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Publi\xE9",
    defaultMessage: "Publi\xE9"
  })
}, {
  value: "refused",
  label: "Refusé",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Refus\xE9",
    defaultMessage: "Refus\xE9"
  })
}, {
  value: "draft",
  label: "Brouillon",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Brouillon",
    defaultMessage: "Brouillon"
  })
}];
exports.STATUS_OPTIONS = STATUS_OPTIONS;
var TABLE_HEAD_COLUMNS = [{
  type: "number",
  label: "tableau_ID",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_ID",
    defaultMessage: "tableau_ID"
  }),
  value: "id",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true
}, {
  type: "string",
  label: "tableau_Nom",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Nom",
    defaultMessage: "tableau_Nom"
  }),
  value: "name",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true,
  editable: true
}, {
  type: "string",
  label: "tableau_Description",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Description",
    defaultMessage: "tableau_Description"
  }),
  value: "description",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: false
}, {
  type: "image",
  label: "tableau_Images",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Images",
    defaultMessage: "tableau_Images"
  }),
  value: "images",
  isAbleToShow: true,
  show: true,
  filtrable: false,
  sortable: false
}, {
  type: "number",
  label: "tableau_Prix_(€)",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Prix_(\u20AC)",
    defaultMessage: "tableau_Prix_(\u20AC)"
  }),
  value: "price",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true,
  editable: true
}, {
  type: "number",
  label: "tableau_Quantité",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Quantit\xE9",
    defaultMessage: "tableau_Quantit\xE9"
  }),
  value: "quantity",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true,
  editable: true
}, {
  type: "list",
  label: "tableau_Statut",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Statut",
    defaultMessage: "tableau_Statut"
  }),
  value: "status",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true,
  options: STATUS_OPTIONS
}, {
  type: "date",
  label: "tableau_Créé_à",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Cr\xE9\xE9_\xE0",
    defaultMessage: "tableau_Cr\xE9\xE9_\xE0"
  }),
  value: "created_at",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: true
}, {
  type: "list",
  label: "tableau_Catégorie",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Cat\xE9gorie",
    defaultMessage: "tableau_Cat\xE9gorie"
  }),
  value: "category.name",
  isAbleToShow: true,
  show: true,
  filtrable: true,
  sortable: false
}, {
  type: "list",
  label: "tableau_Spécificité",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "tableau_Sp\xE9cificit\xE9",
    defaultMessage: "tableau_Sp\xE9cificit\xE9"
  }),
  value: "specificity",
  isAbleToShow: true,
  show: false,
  specificities: [],
  filtrable: true,
  sortable: false
}];

// Array of strings to store the column names of the table
exports.TABLE_HEAD_COLUMNS = TABLE_HEAD_COLUMNS;
var ALL_HEAD_COLUMNS_WITH_SPECIFICITIES = [];

// Array of strings to store the specificities values
exports.ALL_HEAD_COLUMNS_WITH_SPECIFICITIES = ALL_HEAD_COLUMNS_WITH_SPECIFICITIES;
var SPECIFICITIES = [];
exports.SPECIFICITIES = SPECIFICITIES;
var ProductsTable = function ProductsTable(_ref) {
  var _ref$headColumns = _ref.headColumns,
    headColumns = _ref$headColumns === void 0 ? TABLE_HEAD_COLUMNS : _ref$headColumns,
    _ref$useProducts = _ref.useProducts,
    useProducts = _ref$useProducts === void 0 ? _tableHooks.useProductsDefault : _ref$useProducts,
    _ref$useCategories = _ref.useCategories,
    useCategories = _ref$useCategories === void 0 ? _tableHooks.useCategoriesDefault : _ref$useCategories,
    _ref$useSpecificities = _ref.useSpecificities,
    useSpecificities = _ref$useSpecificities === void 0 ? _tableHooks.useSpecificitiesDefault : _ref$useSpecificities,
    intl = _ref.intl,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var _useProducts = useProducts(),
    _useProducts2 = _slicedToArray(_useProducts, 2),
    appliedFilter = _useProducts2[0],
    setAppliedFilter = _useProducts2[1];
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    drawerWidth = _useState2[0],
    setDrawerWidth = _useState2[1];
  var _useState3 = (0, _react.useState)(headColumns),
    _useState4 = _slicedToArray(_useState3, 2),
    tableHeadColumns = _useState4[0],
    setTableHeadColumns = _useState4[1];
  // this state is used to store the columns that the user wants to see
  // and it's an array of strings to store the column names of the table
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    shownTableHeadColumns = _useState6[0],
    setShownTableHeadColumns = _useState6[1];
  useCategories();
  useSpecificities();
  (0, _reactUse.useTitle)(intl.formatMessage({
    id: "ProductsTableTable title",
    defaultMessage: "ProductsTableTable title"
  }));
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        specificities: state.specificityOfProductReducer.specificities,
        products: state.productSalableReducer.productSalables,
        inProgress: state.productSalableReducer.inProgress,
        pagination: state.productSalableReducer.pagination
      };
    }),
    products = _useSelector.products,
    inProgress = _useSelector.inProgress,
    pagination = _useSelector.pagination,
    specificities = _useSelector.specificities;
  (0, _react.useEffect)(function () {
    var _props$nameInLocalSto = props.nameInLocalStorage,
      nameInLocalStorage = _props$nameInLocalSto === void 0 ? "salableProducts" : _props$nameInLocalSto;
    var headColumnsFromStorage = JSON.parse(localStorage.getItem("tableHeadColumns_".concat(nameInLocalStorage)));
    var specificitiesColumns = [];
    // we must reset ALL_HEAD_COLUMNS_WITH_SPECIFICITIES and SPECIFICITIES arrays to avoid duplicates
    exports.ALL_HEAD_COLUMNS_WITH_SPECIFICITIES = ALL_HEAD_COLUMNS_WITH_SPECIFICITIES = [];
    exports.SPECIFICITIES = SPECIFICITIES = [];
    if ((specificities === null || specificities === void 0 ? void 0 : specificities.length) > 0) {
      specificitiesColumns = specificities.map(function (specificity) {
        var value = specificity.name.toLowerCase();
        ALL_HEAD_COLUMNS_WITH_SPECIFICITIES.push(value);
        SPECIFICITIES.push(value);
        return {
          id: specificity.id,
          label: specificity.name,
          value: value
        };
      });
    }
    var newShownTableHeadColumns = [];
    var newTableHeadColumns = tableHeadColumns.map(function (headColumn) {
      var isString = typeof headColumn.value === 'string';
      if (headColumn.isAbleToShow) ALL_HEAD_COLUMNS_WITH_SPECIFICITIES.push(isString ? headColumn.value : headColumn.filtreValue);
      if (headColumn.show) {
        newShownTableHeadColumns.push(isString ? headColumn.value : headColumn.filtreValue);
      }
      if (headColumn.value === "specificity") {
        return _objectSpread(_objectSpread({}, headColumn), {}, {
          specificities: specificitiesColumns
        });
      }
      return headColumn;
    });
    setShownTableHeadColumns(headColumnsFromStorage || newShownTableHeadColumns);
    setTableHeadColumns(newTableHeadColumns);
  }, [specificities]);
  (0, _react.useEffect)(function () {
    var time = setTimeout(function () {
      var _document$querySelect;
      var width = (_document$querySelect = document.querySelector(".MuiDrawer-root.MuiDrawer-docked")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientWidth;
      if (width !== drawerWidth) {
        setDrawerWidth(width);
      }
    }, 100);
    return function () {
      return clearTimeout(time);
    };
  });
  var handleChangePage = function handleChangePage(event, newPage) {
    setAppliedFilter(_objectSpread(_objectSpread({}, appliedFilter), {}, {
      _page: newPage + 1
    }));
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setAppliedFilter(_objectSpread(_objectSpread({}, appliedFilter), {}, {
      _page: 1,
      _per_page: parseInt(event.target.value, 10)
    }));
  };
  var filteredHeadColumns = (0, _react.useMemo)(function () {
    return tableHeadColumns.filter(function (_ref2) {
      var value = _ref2.value,
        specificities = _ref2.specificities,
        filtreValue = _ref2.filtreValue;
      if (value === "specificity") {
        return specificities.some(function (_ref3) {
          var value = _ref3.value;
          return shownTableHeadColumns.includes(value);
        });
      }
      return shownTableHeadColumns.includes(typeof value === 'string' ? value : filtreValue);
    }).map(function (headColumn) {
      if (headColumn.value === "specificity") {
        return _objectSpread(_objectSpread({}, headColumn), {}, {
          specificities: headColumn.specificities.filter(function (_ref4) {
            var value = _ref4.value;
            return shownTableHeadColumns.includes(value);
          })
        });
      }
      return headColumn;
    });
  }, [shownTableHeadColumns, tableHeadColumns]);
  var _props$tableToolbarCo = props.tableToolbarComponent,
    TableToolbarComponent = _props$tableToolbarCo === void 0 ? _TableToolbar.TableToolbar : _props$tableToolbarCo,
    _props$tableHeadCompo = props.tableHeadComponent,
    TableHeadComponent = _props$tableHeadCompo === void 0 ? _CustomTableHead.default : _props$tableHeadCompo,
    _props$tableBodyCompo = props.tableBodyComponent,
    TableBodyComponent = _props$tableBodyCompo === void 0 ? _CustomTableBody.CustomTableBody : _props$tableBodyCompo;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(TableToolbarComponent, _extends({
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter,
    shownTableHeadColumns: shownTableHeadColumns,
    setShownTableHeadColumns: setShownTableHeadColumns,
    tableHeadColumns: tableHeadColumns,
    filteredHeadColumns: filteredHeadColumns
  }, props)), /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    style: {
      maxWidth: "calc(100vw - ".concat(drawerWidth || 0, "px)")
    },
    component: _core.Paper
  }, inProgress ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.circularProgressWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null)) : /*#__PURE__*/_react.default.createElement(_core.Table, {
    "aria-label": "products table",
    className: classes.table
  }, /*#__PURE__*/_react.default.createElement(TableHeadComponent, {
    filteredHeadColumns: filteredHeadColumns,
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter
  }), /*#__PURE__*/_react.default.createElement(TableBodyComponent, _extends({}, props, {
    products: products,
    filteredHeadColumns: filteredHeadColumns
  })))), /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    rowsPerPageOptions: [5, 10, 25, 50],
    component: "div",
    count: pagination.count || 0,
    rowsPerPage: appliedFilter._per_page || 10,
    page: appliedFilter._page - 1 || 0,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  })));
};
var _default = (0, _Translations.injectIntl)(ProductsTable);
exports.default = _default;